import { PureComponent } from 'react'

export interface ChartVisualizationManagerChildProps<TChartVisualization> {
  readonly isChartContainerCollapsed: boolean
  readonly chartVisualization?: TChartVisualization
  readonly onChartContainerToggle: () => void
  readonly onChartVisualizationToggle: (
    chartVisualization: TChartVisualization
  ) => void
}

interface ChartVisualizationManagerProps<TChartVisualization> {
  readonly isChartContainerCollapsed?: boolean
  readonly chartVisualization?: TChartVisualization
  readonly children: (
    props: ChartVisualizationManagerChildProps<TChartVisualization>
  ) => React.ReactNode
}

interface ChartVisualizationManagerState<TChartVisualization> {
  readonly isChartContainerCollapsed: boolean
  readonly chartVisualization?: TChartVisualization
}

export class ChartVisualizationManager<
  TChartVisualization
> extends PureComponent<
  ChartVisualizationManagerProps<TChartVisualization>,
  ChartVisualizationManagerState<TChartVisualization>
> {
  public constructor(props) {
    super(props)

    const { chartVisualization, isChartContainerCollapsed = true } = props // TODO BBV change isChartContainerCollapsed to FALSE when charts are integrated

    this.state = {
      isChartContainerCollapsed,
      chartVisualization
    }
  }

  public render() {
    const { isChartContainerCollapsed, chartVisualization } = this.state
    const { children } = this.props

    return children({
      isChartContainerCollapsed,
      chartVisualization,
      onChartContainerToggle: this.onChartContainerToggle,
      onChartVisualizationToggle: this.onChartVisualizationToggle
    })
  }

  private onChartContainerToggle = () => {
    this.setState(({ isChartContainerCollapsed }) => ({
      isChartContainerCollapsed: !isChartContainerCollapsed
    }))
  }

  private onChartVisualizationToggle = (
    chartVisualization: TChartVisualization
  ) => {
    this.setState({
      chartVisualization
    })
  }
}
